$(document).ready(function() {
  
  $(".product .thumbnail-slider .thumbnail-list__item.slider__slide button.devVideo").on('click', function(){
    $('.product .product__media-list .product__media-item video').trigger('play');
    $(".product .thumbnail-slider .thumbnail-list__item.slider__slide button").removeAttr('aria-current');
    $(".product .thumbnail-slider .thumbnail-list__item.slider__slide button.devVideo").attr('aria-current' , true);
  });

  $('.product-form__input label').on('click', function(){
    setTimeout( function(){
    var vID = document.URL.split('?variant=')[1];
    //console.log('vID is = ' + vID );
      
    $('.devVars span').each( function(){
      
      if( vID == $(this).attr('data-varID') ){
        $('.devSelectOption').hide();
        if( $(this).attr('data-avail') == 'true' && $(this).attr('data-Qty') > 0 ){
          $('.devInStock').show();
          $('.devOutStock').hide();
        } else {
          $('.devInStock').hide();
          $('.devOutStock').show();
        }
      }
    })
    if (vID !== undefined) {
      $('button.product-form__submit').prop("disabled", false);
    }
    }, 500);
  });

});